import { render, staticRenderFns } from "./OrderImport.vue?vue&type=template&id=a20e6896&"
import script from "./OrderImport.vue?vue&type=script&lang=js&"
export * from "./OrderImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports